export const initialMcaOptions = {
    paLines: 2,
    bright: 80,
    font: 2,
    width: 25,
};
//# sourceMappingURL=initialMcaOptions.js.map